// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  //   Dialog,
  //   DialogContent,
  //   DialogContentText,
  //   DialogTitle,
  //   DialogActions,
  Icon,
  //   Divider,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useEffect, useState } from "react";
import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import PayPalHeader from "./header";

function PayeerSell() {
  const title = "Sell Payeer";
  usePageTitle(title);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [initParams, setInitParams] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [amount, setAmount] = useState(null);
  const [fiatAmount, setFiatAmount] = useState(null);
  const [transactionFee, setTransactionFee] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`ewallets/payeer/init.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setInitParams(result.data.data);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function calculateFee(trxAmount) {
    const feeObject = initParams.fee;
    let tFee = feeObject.fee;
    if (feeObject.is_percentage) {
      tFee = trxAmount * feeObject.fee;
      if (feeObject.minimum > 0) {
        tFee = feeObject.minimum > tFee ? feeObject.minimum : tFee;
      }

      if (feeObject.maximum > 0) {
        tFee = feeObject.maximum < tFee ? feeObject.maximum : tFee;
      }

      tFee += feeObject.mandatory_fee;
    }

    let cDiscount = feeObject.discount;
    if (feeObject.is_discount_percentage) {
      cDiscount = tFee * feeObject.discount;
    }

    tFee -= cDiscount;
    return tFee / 100;
  }

  useEffect(() => {
    if (currency === null || amount === null) {
      return;
    }

    let xAmt = (initParams.rates[currency].sell * amount) / 100;
    const fee = calculateFee(xAmt * 100);
    xAmt -= fee;
    setFiatAmount(xAmt);
    setTransactionFee(fee);
  }, [currency, amount]);

  const [senderAccount, setSenderAccount] = useState(null);
  const [transactionID, setTransactionID] = useState(null);

  async function sell() {
    if (currency === null) {
      setSeverity("error");
      setErrMsg("Enter the currency sent.");
      setOpen(true);
      return;
    }

    if (amount === null) {
      setSeverity("error");
      setErrMsg("Enter the amount sent.");
      setOpen(true);
      return;
    }

    if (senderAccount === null) {
      setSeverity("error");
      setErrMsg("Enter the sender's payeer account ID from which payment was made.");
      setOpen(true);
      return;
    }

    if (transactionID === null) {
      setSeverity("error");
      setErrMsg("Enter the transaction ID of the payment made.");
      setOpen(true);
      return;
    }

    const postParams = {
      digital_wallet: "PAYEER",
      sender_account: senderAccount,
      payment_reference: transactionID,
    };

    setShowLoading(true);
    const json = JSON.stringify(postParams);
    await axios
      .post("ewallets/payeer/sell.json", json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
        } else {
          setSeverity("error");
        }
        setErrMsg(result.data.data.message);
        setOpen(true);
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <PayPalHeader />
      <MDBox pt={3} pb={3}>
        <Card>
          <MDBox p={3}>
            <MDBox mt={1}>
              <MDBox>
                <MDBox mt={1}>
                  <Grid container spacing={8}>
                    <Grid item xs={12} lg={6} md={6}>
                      <MDBox mb={3}>
                        <MDTypography variant="h6">Payment Instructions</MDTypography>
                      </MDBox>
                      <MDTypography variant="h6" fontWeight="light">
                        Transfer funds to our receiving account below. Enter the transaction ID of
                        the payment and the sender email, submit the form to receive credit
                        instantly.
                      </MDTypography>
                      <MDBox mt={3}>
                        <MDTypography variant="h6" fontWeight="light">
                          {initParams !== null ? (
                            initParams.accounts.map((record) => (
                              <p>
                                <b>Receiving Account: </b> &nbsp;{record.account} &nbsp;
                                <Icon
                                  onClick={() => {
                                    navigator.clipboard.writeText(record.account);
                                    setSeverity("success");
                                    setErrMsg(`Account copied!`);
                                    setOpen(true);
                                  }}
                                >
                                  copy
                                </Icon>
                              </p>
                            ))
                          ) : (
                            <> </>
                          )}
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDTypography variant="h6" fontWeight="light">
                          <p>Sell Rates</p>
                          {initParams !== null ? (
                            initParams.currencies.map((record) => (
                              <p>
                                <small>
                                  <b>{record}: </b> &nbsp; NGN{" "}
                                  {(initParams.rates[record].sell / 100).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}{" "}
                                  / 1.00 {record}
                                </small>
                              </p>
                            ))
                          ) : (
                            <> </>
                          )}
                        </MDTypography>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={6} md={6}>
                      <MDBox>
                        <MDBox mb={3}>
                          <MDTypography variant="h6">Withdraw Order</MDTypography>
                        </MDBox>
                        <Grid container spacing={1}>
                          <Grid item xs={4} md={4} lg={4}>
                            <FormControl sx={{ width: "100%" }}>
                              <InputLabel>Currency</InputLabel>
                              <Select
                                label="Currency"
                                sx={{ padding: "12px", paddingLeft: "3px" }}
                                onChange={(e) => setCurrency(e.target.value)}
                              >
                                {
                                  // --> Notice below changes
                                  initParams !== null && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                    initParams.currencies.map((record) => (
                                      <MenuItem value={record}>{record}</MenuItem>
                                    ))
                                }
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={8} md={8} lg={8}>
                            <MDInput
                              onChange={(e) => {
                                setAmount(e.target.value);
                              }}
                              label="Amount Sent"
                              sx={{ width: "100%" }}
                              type="decimal"
                            />
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDInput
                          sx={{ width: "100%" }}
                          onChange={(e) => {
                            setSenderAccount(e.target.value);
                          }}
                          label="Sender Payeer Account ID"
                        />
                      </MDBox>
                      <MDBox mt={3}>
                        <MDInput
                          onChange={(e) => {
                            setTransactionID(e.target.value);
                          }}
                          label="Transaction ID"
                          sx={{ width: "100%" }}
                        />
                      </MDBox>

                      <MDBox mt={3}>
                        {fiatAmount !== null ? (
                          <MDBox mt={2}>
                            <Alert severity="info" sx={{ width: "100%" }}>
                              <MDBox>
                                <small variant="caption" fontWeight="heavy">
                                  Ex. Rate:{" "}
                                  {(initParams.rates[currency].sell / 100).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </small>
                              </MDBox>
                              <MDBox>
                                <small variant="caption" fontWeight="medium">
                                  Fee: NGN{" "}
                                  {transactionFee.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </small>
                              </MDBox>
                              <MDBox>
                                <small variant="caption" fontWeight="medium">
                                  You Get: NGN{" "}
                                  {fiatAmount.toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </small>
                              </MDBox>
                            </Alert>
                          </MDBox>
                        ) : (
                          <> </>
                        )}
                      </MDBox>

                      <MDBox mt={4} mb={2} align="right">
                        <MDButton
                          color="info"
                          variant="contained"
                          onClick={() => {
                            sell();
                          }}
                          sx={{ align: "right" }}
                        >
                          Process Order
                        </MDButton>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </MDBox>
            <MDBox mt={4}>
              <Alert severity="info">
                <b>Tip</b>: To get your transaction ID after transfer, log into your Payeer account,
                go to history, locate the tansaction and copy the transaction ID.
              </Alert>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PayeerSell;
